import React from 'react';
import ReportViewer from "./base/ReportViewer";

const ListeClients = () => {

    return (
        <div style={{height: "100%"}}>
            <ReportViewer reportName={"Listeclientreport"}/>
        </div>
    );
}
export default ListeClients;